<template>
    <div>
        <div>
            <b-form-select v-model="selected" :options="options" class="select"></b-form-select>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../../config';
export default {
    name: 'targetGroup',
    created: async function() {
        await axios
            .get(`${path}templates`)
            .then(response => (
                this.templates = response.data
            ))
            .catch(e => (
                console.log(e)
            ))
            this.setTemplates();
    },
    updated: function(){
        this.$emit('sendMessage', this.selected)
    },
    methods: {
        setTemplates: async function(){
            for(let item of this.templates){
                let checkTopic = this.topicList.includes(item.topic);
                if(!checkTopic){
                    await this.topicList.push(item.topic)
                    await this.options.push({label: item.topic, options:[{value: item.message, text: item.message}]})
                }   else {
                    let existingTopicItem = this.options.find(findItem => findItem.label === item.topic)
                    existingTopicItem.options.push({value: item.message, text: item.message})
                }
            }
        }
    },
    data: function(){
        return{
            templates: '',
            topicList: [],
            selected: '',
            options: [
                {value: '', disabled: true, text: 'Wybierz temat i treść'},
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .select {
        margin-bottom: 10px;
    }
</style>